import dayjs from 'dayjs'

export const formatShiftCloseoutDate = (date: string | Date): string => {
    const formattedDate = dayjs(date).format('dddd D. M. YYYY, HH:mm')

    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
}
